export default __webpack_public_path__ + "static/media/gallery-wip-head-pins_03.db697dc8.jpg";